import React from 'react';

import { ArticlePickup } from '@interfaces/homepage';
import { article_path, brand_campaign_path } from '@routes';

import { SecondaryButton } from '../Button/variants';
import IconRedLine from '../Images/Rebranding/IconRedLine';
import { SectionTitle } from './SectionTitle';

interface ArticlePickupsProps {
  articlePickups: ArticlePickup[];
}

const ArticlePickups = ({ articlePickups }: ArticlePickupsProps) => {
  return (
    <div className="mb-64">
      <SectionTitle title="Reported here first" />
      {articlePickups.map(({ title, slug, pickups }, index) => (
        <div key={`${title}-${index}`} className="mb-32">
          <h2 className="mb-8 mt-0 font-suisse-neue text-body-md text-primary-black lg:text-subheadline-sm">
            <a href={article_path(slug)} className="text-inherit">
              {title}
            </a>
          </h2>
          <div className="relative overflow-y-hidden pl-[21px]">
            <IconRedLine className="absolute left-0 top-10 w-[17px]" />
            <h4 className="m-0 font-suisse-intl-mono text-caption-sm text-primary-magenta">
              followed by
            </h4>
            {pickups.map(({ title, url, publication }, index) => (
              <h2
                key={`${title}-${index}`}
                className="relative mb-0 mt-10 font-suisse-neue text-body-md text-grayscale-gray before:absolute before:left-[-21px] before:top-8 before:z-[-1] before:h-10 before:w-10 before:rounded-full before:bg-primary-magenta before:content-[''] lg:text-body-lg"
              >
                <a href={url} target="_blank" className="text-inherit" rel="noopener">
                  {publication && `${publication}: `}
                  {title}
                </a>
              </h2>
            ))}
          </div>
        </div>
      ))}
      <SecondaryButton
        as="link"
        href={brand_campaign_path()}
        className="!px-28 py-6 lg:py-12"
        fullWidth
      >
        View more
      </SecondaryButton>
    </div>
  );
};

export default ArticlePickups;
